export default {"src":"/_next/static/media/radiodot.8b1bfa5b.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};